import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import schoolDate from "./SchoolDate.vue";
import note from "./Note.vue";
import schedule from "./Schedule.vue";
import affair from "./affair.vue";
import { getCardList } from "@/api/managementCenter/specialManage";
export default {
  name: "cardC",
  components: {
    draggable: draggable,
    schoolDate: schoolDate,
    note: note,
    schedule: schedule,
    affair: affair
  },
  props: ["childModules", "homeModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      noticeList: [],
      policyFileList: []
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {
    this.getCardData("0");
    this.getCardData("1");
  },
  methods: {
    getCardData: function getCardData(type) {
      var _this = this;

      var params = {
        type: type || ""
      };
      getCardList(params).then(function (res) {
        if (type == "0") {
          _this.noticeList = res.data.data.records;
        }

        if (type == "1") {
          _this.policyFileList = res.data.data.records;
        }
      });
    },
    addClick: function addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected: function ifSelected(val) {
      var cardModule = this.homeModules.find(function (item) {
        return item.cardType === "CARD";
      });

      if (cardModule) {
        if (cardModule.cardModules) {
          return cardModule.cardModules.some(function (item) {
            return item.code === val.code;
          });
        }

        return false;
      }

      return false;
    }
  },
  watch: {},
  filters: {}
};